/* Top-level component — routes only. Providers live in main.tsx. */

import { AppRoutes } from './routes';

export function App(): JSX.Element {
  return <AppRoutes />;
}
